import Script from 'next/script'
import { useEffect } from 'react'

import {
  hideZendeskMessenger,
  showZendeskMessenger,
  ZENDESK_SNIPPET_SRC,
} from '@/lib/zendesk/messengerWidget'

/**
 * Zendesk messaging widget for Altair TOP.
 * Script loads once; hide on unmount so the bubble does not persist on other pages.
 */
export const ZendeskMessengerWidget = () => {
  useEffect(() => {
    showZendeskMessenger()

    return () => {
      hideZendeskMessenger()
    }
  }, [])

  return (
    <Script
      id="ze-snippet"
      src={ZENDESK_SNIPPET_SRC}
      strategy="afterInteractive"
      onLoad={showZendeskMessenger}
    />
  )
}
